import { DELETE_Route } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const DeleteRoute = async (id) => {
  try {
    const resp = await apiClient.delete(DELETE_Route(id), {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
